/**
 * Module-level debug mode flag.
 * Set during app initialization from Supabase query, read by hooks.
 */
let _isDebugMode = false

export function setAppDebugMode(value: boolean): void {
  _isDebugMode = value
}

export function getAppDebugMode(): boolean {
  return _isDebugMode
}
